import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'

import {
    Mona_Sans,
    IBM_Plex_Mono,
    Smooch
} from 'next/font/google'

const sans = Mona_Sans({
    subsets: ['latin'],
    axes: ['wdth'],
    display: 'swap'
})

const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    display: 'swap'
})

const script = Smooch({
    subsets: ['latin'],
    weight: '400',
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily};--font-app-script:${script.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
